module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABRklEQVRYR+1XsUrEQBScCeol6sEJNn6HFpbXaSl7foCCIrnKP7C5zuKqS0r9gWijvZ9xhYVlsDkLyQl6eRIEEQmbbFg4CJt2J8wwPObNo4o/LoB8RHAbuk8kFXhnd0P/UYszfKSKshnINwJPWn6gTxE/Ga7vGHJo4RzEcwFwm4TBqQ45iOc3AE6SMGAZrj953dxid9dE3AJMrQlQUXZJcmwiAMC7NQFH41mPq51Dkn5dEQJ5tiagLul/nBPQHgdUlO0DvCJRewghmP4GESqCCEUQAX4SBqVBpCbZMTxemwwjgRf+RLGMCOijGEhz5Of34caDCUkVtjTVqn6y+e4EOAecA8t3oDWdsHEU2+qEzZYRp+1Zx033g3PAmgNFLffWOgdGtZwr9mp5k8NExOJhUpxmPa+7ZzKMi6/P1FonNCH+i116J/wGR/cBOXp/hB0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/study/icon/switch_transverse.png
// module id = BqZ3
// module chunks = 96